<template>
  <div class="col-lg-12 pb-4 border">
    <div class="card">
      <div class="card-body">
        <div v-if="target">
          <h4 class="card-title mb-4">
            <div class="row">
              <div class="col-4">
                <h6 class="text-muted mb-2">
                  <b>*{{ $t("telegram.example") }} :</b> 6285790422395 /
                  KangKuman
                </h6>
                <div class="input-group mt-2">
                  <input
                    id="search"
                    type="text"
                    class="form-control"
                    placeholder="phone number or username.."
                    v-model="searchKeyUsers"
                    aria-describedby="search"
                    v-on:input="removeSpace(searchKeyUsers)"
                    @keyup.enter="SearchUsersTele"
                  />
                  <div class="input-group-prepend">
                    <button
                      id="search"
                      class="input-group-text bg-primary text-white"
                      @click="SearchUsersTele"
                    >
                      <i class="bx bx-search-alt search-icon"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-8 text-right">
                <b-button
                  @click="refresh"
                  class="btn btn-sm p-0 px-1 mx-2"
                  variant="success"
                  v-if="
                    user_type === 'superadmin' ||
                    user_type === 'admin' ||
                    user_type === 'vvip'
                  "
                  ><i
                    :class="loading ? 'mdi-spin' : ''"
                    class="mdi mdi-18px mdi-refresh p-0"
                  ></i
                ></b-button>
              </div>
            </div>
          </h4>
          <!-- <h1>{{search_member_telegram}}</h1> -->
          <div class="hori-timeline">
            <cytoscape
              v-if="dataTelegram"
              ref="cyRef"
              :afterCreated="afterCreated"
              :preConfig="preConfig"
              :config="config"
              v-on:mousedown="addNode"
              @click="link"
              v-on:cxttapstart="tapNode"
            >
            </cytoscape>

            <div v-else class="row mt-5 mb-5 pb-4">
              <div class="text-center m-5 p-5 col-12">
                <b-spinner label="Loading..."></b-spinner>
                <br />
                loading..
              </div>
            </div>
          </div>
        </div>
        <div v-if="loadingnew" class="mt-4 mx-auto p-5">
          <div class="text-center">
            <div
              class="spinner-border text-secondary"
              role="status"
              v-if="loadingnew"
            >
              <span class="sr-only"
                ><p>{{ $t("website.website-info") }}</p></span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";
import appConfig from "@/app.config";
import TargetService from "@/helpers/target-profile.service";
import PreferenceService from "@/helpers/preference.service.js";
import GroupService from "@/helpers/group.service.js";
import TwintService from "@/helpers/twint.service";
import cola from "cytoscape-cola";
import cola2 from "cytoscape-cola";
import noOverlap from "cytoscape-no-overlap";
import cytoscape from "cytoscape";
import coseBilkent from "cytoscape-cose-bilkent";

export default {
  props: ["user_type"],
  // page: {
  //   title: "Timeline",
  //   meta: [{ name: "description", content: appConfig.description }]
  // },
  components: { Carousel, Slide },

  data() {
    var baseUrl = window.location.origin;
    return {
      search_member_telegram: false,
      searchKeyUsers: "",
      loading_search_users: false,
      search_users: false,
      error_users: "",
      baseUrl: baseUrl + "/project-overview/",
      loadingnew: false,
      dataRelation: false,
      dataWordCloud: false,
      dataFollow: false,
      dataTelegram: false,
      elastic: "",
      target: [],
      title: "Ontology",
      cy: null,
      config: {
        layout: {
          name: "cola",
          animate: true,
          nodeSpacing: 5,
          edgeLengthVal: 45,
          maxSimulationTime: 2000,
          fit: true,
          randomize: false,
          avoidOverlap: true,
        },
        style: [
          {
            selector: "node[id='telegrup']",
            style: {
              width: "50px",
              height: "50px",
              content: "data(label)",
              "text-transform": "uppercase",
              color: "#bf151c",
              "font-size": "14px",
              "font-weight": "bold",
              "text-valign": "center",
              "text-halign": "center",
              "background-color": "#bf151c",
              "text-outline-color": "#118bc4",
              "text-outline-width": "2px",
              color: "#fff",
              "overlay-padding": "6px",
              "z-index": "10",
            },
          },
          {
            selector: "node[parent_node='telegramgroup']",
            style: {
              width: "30px",
              height: "30px",
              content: "data(label)",
              "text-transform": "lowercase",
              color: "#555555",
              "font-size": "12px",
              "text-valign": "center",
              "text-halign": "center",
              "background-color": "#118bc4",
              "text-outline-color": "#118bc4",
              "text-outline-width": "2px",
              color: "#fff",
              "overlay-padding": "6px",
              "z-index": "10",
            },
          },
          {
            selector: "edge[target='telegrup']",
            style: {
              width: 2,
              "line-color": "#bf151c",
              "target-arrow-color": "#F76300",
            },
          },
        ],
        elements: {
          nodes: [
            {
              data: {
                id: "telegrup",
                label: "TELEGRAM",
              },
            },
          ],
          edges: [],
        },
      },

      items: [
        {
          text: "galaxy",
          href: "/",
        },
        {
          text: "galaxy",
          active: true,
        },
      ],
      loading: false,
    };
  },
  methods: {
    getPreferences() {
      PreferenceService.getAllElastic()
        .then((response) => {
          this.elastic = response.data.data[0].ip_address;
          this.getGrupTelegram();
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async getGrupTelegram() {
      const name = "telegram";
      await GroupService.getTelegramGroupElastic(this.elastic, name)
        .then((response) => {
          let listTelegram = response.data._source.listgroup;
          // console.log('data', response.data._source);
          // const listTelegram = [ { "no": 1, "title": "PESUGIHAN AMANAH", "username": "pinturezeki01", "participants_count": 13113, "date": "2022-10-19", "about": "ᴍᴇʟᴀʏᴀɴɪ ʙᴀɢɪ ᴀɴᴅᴀ ᴘᴜɴʏᴀ ᴍᴀsᴀʟᴀʜ👇\n⭕ ᴅᴀɴᴀ ɢᴏɪʙ / ᴘᴇsᴜɢɪʜᴀɴ\n⭕ ᴘᴇɴɢʟᴀʀɪs ᴜsᴀʜᴀ\n⭕ ᴘᴜᴛᴇʀ ɢɪʟɪɴɢ\n⭕ ʙɪsɴɪs & ᴘᴏʟɪᴛɪᴋ\n⭕ ᴀsᴍᴀʀᴀ\n⭕ ᴋᴀʀɪʀ\n⭕ ᴋᴇᴛᴜʀᴜɴᴀɴ\n⭕ ᴅʟʟ. ɪɴғᴏ ʟᴇʙɪʜ ʟᴀɴᴊᴜᴛ\nʜᴜʙᴜɴɢɪ ᴀᴅᴍɪɴ : 👇\nWa.me/+6285319129763\nɪɴsʏᴀ ᴀʟʟᴀʜ, sᴇᴍᴜᴀɴʏᴀ ʙɪsᴀ ᴅɪsᴇʟᴇsᴀɪᴋᴀɴ 💯%" }, { "no": 2, "title": "CARI AYANG VIRTUAL", "username": "CariAyangVirtuall", "participants_count": 142996, "date": "2022-09-27", "about": "SELAMAT DATANG DI Cari Ayang Virtual😇\nGRUP CARI TEMAN & CARI AYANG\n\nBOT DONASI (@Cariayangbot) UNTUK KAMU YG FOTONYA INGIN DI POST DI CHANNEL = @CariAyangIndo" }, { "no": 3, "title": "Jadi Hacker", "username": "ternakhacker", "participants_count": 8388, "date": "2022-11-01", "about": "Improving Indonesia's Cyber Security\n\nhttps://jadihacker.id" }, { "no": 4, "title": "LOWONGAN INDONESIA🇲🇨", "username": "lowongan_indonesia", "participants_count": 117901, "date": "2022-11-18", "about": "Group Lowongan Kerja All Area Indonesia, ada ratusan lowongan setiap hari di group ini, member nya sudah lebih 117 ribu, link join group https://t.me/Lowongan_Indonesia" }, { "no": 6, "title": "EcHo ( 2003 - present )", "username": "ECHOrdc", "participants_count": 921, "date": "2022-11-19", "about": "Indon[E]sian [C]ommunity for [H]acker and [O]pensource" }, { "no": 7, "title": "Flutter Indonesia", "username": "flutter_id", "participants_count": 20102, "date": "2022-11-08", "about": "Flutter Indonesia User Group\nFB Group: https://www.facebook.com/groups/1738284952897937/" }]
          listTelegram.forEach((val, index) => {
            const data_top_nodes = {
              data: {
                id: "top-" + index,
                label: val.username,
                parent_node: "telegramgroup",
              },
              username: val.username,
            };
            if (val.username) {
              this.config.elements.nodes.push(data_top_nodes);
              const data_top_edges = {
                data: { source: "top-" + index, target: "telegrup" },
              };
              this.config.elements.edges.push(data_top_edges);
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
      this.dataTelegram = true;
    },

    addNode(event) {
      // var node = event.target;
      // var type = node.data('parent_node');
      console.log("Tap NOdee", event.cy._private);
      console.log("Tap NOdee 2", this.$refs.cyRef);
      event.cy.on("tap", "node", function (evt) {
        let node = evt.target;
        console.log("TAPPPPED ", node);
      });
      event.cy.layout(this.config.layout).run();
      // cy.animate(
      //   // {
      //   //   position: { x: 100, y: 100 },
      //   //   style: { backgroundColor: "red" },
      //   // },
      //   {
      //     duration: 1000,
      //   }
      // );
    },

    SearchUsersTele() {
      // console.log(data);
      if (this.searchKeyUsers != "") {
        this.loading_search_users = true;
        // this.SearchResultUsers = [];
        // this.userList = "";
        (this.error_users = ""), (this.search_users = true);
        let sk = this.searchKeyUsers.substring(0, 2);
        if (sk == "62") {
          var data_search = {
            size: 1000,
            query: {
              match: {
                "listmember.phone.keyword": this.searchKeyUsers,
              },
            },
          };
        } else {
          var data_search = {
            size: 1000,
            query: {
              match: {
                "listmember.username.keyword": this.searchKeyUsers,
              },
            },
          };
        }
        console.log(data_search);
        this.search_member_telegram = true;
        GroupService.SearchGroupByPhone(this.elastic, data_search)
          .then((response) => {
            console.log(response.data.hits);
            let listTelegram = response.data.hits.hits;
            // var username =  response.data.hits.hits[0]._id;
            this.config.elements.nodes.push([
              {
                data: {
                  id: "telegrup",
                  label: "KUMAN",
                },
              },
            ]);
            this.config.elements.edges = [
              {
                data: {
                  source: "telegrup",
                  target: "telegrup",
                },
              },
            ];

            listTelegram.forEach((val, index) => {
              const data_top_nodes = {
                data: {
                  id: "top-" + index,
                  label: val._id,
                  parent_node: "telegramgroup",
                },
              };
              console.log(data_top_nodes);
              this.config.elements.nodes.push(data_top_nodes);
              const data_top_edges = {
                data: { source: "top-" + index, target: "telegrup" },
              };
              this.config.elements.edges.push(data_top_edges);
            });

            this.refresh();
            console.log("refreshhh");

            this.search_member_telegram = true;
          })
          .catch((err) => {
            console.log(err);
            this.loading_search_users = false;
            console.log("sts", this.loading_search_users);
            if (err.response.status == 500) {
              this.error_users = this.$t("all.error-500");
            } else if (err.response.status == 404) {
              this.error_users = this.$t("all.error-404");
            }
          });
        this.dataTelegram = true;
      }
    },

    addNode(event) {
      // var node = event.target;
      // var type = node.data('parent_node');
      // console.log(type);
    },

    SearchUsersTele() {
      // console.log(data);
      if (this.searchKeyUsers != "") {
        this.loading_search_users = true;
        // this.SearchResultUsers = [];
        // this.userList = "";
        (this.error_users = ""), (this.search_users = true);
        let sk = this.searchKeyUsers.substring(0, 2);
        if (sk == "62") {
          var data_search = {
            size: 1000,
            query: {
              match: {
                "listmember.phone.keyword": this.searchKeyUsers,
              },
            },
          };
        } else {
          var data_search = {
            size: 1000,
            query: {
              match: {
                "listmember.username.keyword": this.searchKeyUsers,
              },
            },
          };
        }
        console.log(data_search);
        this.search_member_telegram = true;
        GroupService.SearchGroupByPhone(this.elastic, data_search)
          .then((response) => {
            console.log(response.data.hits);

            let listTelegram = response.data.hits.hits;
            // var username =  response.data.hits.hits[0]._id;
            this.config.elements.nodes = [
              {
                data: {
                  id: "telegrup",
                  label: this.searchKeyUsers,
                },
              },
            ];
            this.config.elements.edges = [];
            listTelegram.forEach((val, index) => {
              const data_top_nodes = {
                data: {
                  id: "top-" + index,
                  label: val._id,
                  parent_node: "telegramgroup",
                },
              };
              console.log(data_top_nodes);
              this.config.elements.nodes.push(data_top_nodes);
              const data_top_edges = {
                data: { source: "top-" + index, target: "telegrup" },
              };
              this.config.elements.edges.push(data_top_edges);
            });
            this.refresh();
            console.log("refreshhh");
            this.search_member_telegram = true;
          })
          .catch((err) => {
            console.log(err);
            console.log("gagalx");
            this.loading_search_users = false;
            console.log("sts", this.loading_search_users);
            if (err.response.status == 500) {
              this.error_users = this.$t("all.error-500");
            } else if (err.response.status == 404) {
              this.error_users = this.$t("all.error-404");
            }
          });
      }
    },

    link(event) {
      var node = event.target;
      var type = node.data("parent_node");
      var key = node.data("username");
      var id_target = node.data("id_target");
      if (type == "telegram") {
        this.$router.push("group-telegram/view/" + key);
      }
    },

    deleteNode(id) {
      // console.log("node clicked", id);
    },

    overMouse(cy) {
      console.log("TAP NODEE ", cy);
      cy.animate;
      // cy.on("tap", "node", function (evt) {
      // });
    },
    tapNode(cy) {
      console.log("TAP NODEE ", cy);
      // cy.on("tap", "node", function (evt) {
      // });
    },

    updateNode(event) {
      console.log("right click node", event);
    },
    preConfig(cytoscape) {
      cytoscape.use(cola);
      // setTimeout(() => {
      // }, 2000);
    },
    preConfig2(cytoscape2) {
      cytoscape2.use(cola2);
    },
    async afterCreated(cy = null) {
      // if (cy !== null) {
      //   this.cy = cy;
      // } else {
      //   cy = this.cy;
      // }
      // await cy;
      // cy.load;
      // cy.userZoomingEnabled(false);
      // this.cy = cy;
      cy.layout(this.config.layout).run();
      // cy.add();
    },

    refresh() {
      this.loading = true;
      this.dataTelegram = false;
      // this.afterCreated();
      // console.log("CY ", this.$refs.cyRef.cy.then());
      // this.$refs.cyRef.cy.then((cy) => {
      //   cy.layout(this.config.layout).run();
      // });

      setTimeout(() => {
        this.dataTelegram = true;
        this.loading = false;
      }, 2000);
    },
    removeSpace(value) {
      let hsl = value.replace(/\s/g, "");
      return (this.searchKeyUsers = hsl);
    },
  },

  filters: {
    upper(value) {
      if (!value) return "";
      value = value.toString();
      return value.toUpperCase();
    },
    lower(value) {
      if (!value) return "";
      value = value.toString();
      return value.toLowerCase();
    },
  },
  beforeMount() {
    // this.getTargetDetail();
    this.getPreferences();
  },
};
</script>
